import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuthStore } from '@store/authStore';
import { AppShellSkeleton } from '@components/layout/AppShellSkeleton';
import { ROUTES } from '@constants/routes';

export const ProtectedRoute = () => {
  const { isAuthenticated, bootstrapped } = useAuthStore();
  const location = useLocation();

  // Auth restore runs before the shell exists; showing the shell skeleton here
  // keeps a reload visually continuous into MainLayout's own skeleton.
  if (!bootstrapped) return <AppShellSkeleton />;
  if (!isAuthenticated) return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  return <Outlet />;
};
